import services from "./data/service-pages.json";

const servicePages = [...services];

export function loadPageData(id) {
  return services.find((service) => service.id === id);
}
